module.exports = __webpack_public_path__ + "img/1D3FCC_051B5F_81A0F2_5579E9-256px.bf4c8e16.png";